export const defaultProps = {
  name: 'Housing',
  columns: [
    {
      name: 'firstName',
      header: 'First Name',
    },
    {
      name: 'lastName',
      header: 'Last Name',
    },
    {
      name: 'email',
      header: 'Email',
    },
    {
      name: 'phone',
      header: 'Phone',
    },
    {
      name: 'createdAt',
      header: 'Created At',
    },
  ],
  searchableFields: ['firstName', 'lastName', 'email'],
}
